var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show)?_c('apexchart',{attrs:{"width":_vm.width,"height":_vm.height,"type":"bar","options":_vm.chartOptions,"series":_vm.series}}):_c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"size":70,"color":"primary","indeterminate":""}}),_c('br'),_c('br'),_c('div',{staticClass:"text-h6"},[_vm._v("Cargando")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }